import { PropsWithChildren } from 'react'
import { Modal, Button } from 'antd'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { useAppSelector } from '../../hooks'

interface IConfirmSaveModalProps {
  isOpen: boolean
  onModalConfirm: () => void
  onModalCancel: () => void
}

export default function ConfirmSaveModal({
  isOpen,
  onModalConfirm,
  onModalCancel,
}: PropsWithChildren<IConfirmSaveModalProps>) {
  const language = useAppSelector(state => state.present.language.value)
  return (
    <Modal
      title={renderTranslation(language, TranslationKeys.confirmChangeModalTitle)}
      open={isOpen}
      closable={true}
      onCancel={onModalCancel}
      width={400}
      footer={null}
      className={'confirm-change-modal'}
    >
      <div className='modal-body-text'>{renderTranslation(language, TranslationKeys.confirmChangeModalBody)}</div>
      <div className='modal-body-btn-box'>
        <Button className='btn confirm-btn' onClick={onModalConfirm}>
          {renderTranslation(language, TranslationKeys.confirmChangeModalConfirm)}
        </Button>
        <Button className='btn decline-btn' onClick={onModalCancel}>
          {renderTranslation(language, TranslationKeys.confirmChangeModalCancel)}
        </Button>
      </div>
    </Modal>
  )
}
